import React from 'react'
import { isEmpty } from 'ramda'
import Cards from '../../../../../../modules/Cards'
import Diary from '../../../../../../modules/Diary'
import InfoCards from './components/InfoCards'
import Confirmation from './components/Confirmation'
import Information from './components/Information'
import OMR from './components/OMR'
import Options from './components/Options'

const Reproduction = ({ cowid, reproduction, biosensors, refetchCow }) => {
    return (
        !isEmpty(reproduction) &&
        <>
            <Cards type='row'>
                {
                    reproduction['info_cards'] &&
                    <InfoCards
                        infoCards={reproduction['info_cards']}
                    />
                }
            </Cards>
            <Cards type='column'>
                {
                    reproduction['info'] &&
                    <Information
                        info={reproduction['info']['info']}
                    />
                }
                {
                    reproduction['confirmation'] &&
                    <Confirmation
                        rowid={reproduction['rowid']}
                        confirmation={reproduction['confirmation']}
                        refetchCow={refetchCow}
                    />
                }
                {
                    reproduction['omr'] && reproduction['omr']['data'] &&
                    <OMR
                        omr={reproduction['omr']}
                    />
                }
                {
                    reproduction['options'] &&
                    <Options
                        cowid={cowid}
                        rowid={reproduction['rowid']}
                        options={reproduction['options']}
                        biosensors={biosensors}
                        refetchCow={refetchCow}
                    />
                }
                {
                    reproduction['diary'] &&
                    <Diary
                        id={cowid}
                        endpointDiary='/rpc/get_cow_procreation_alerts'
                        endpointNote='/rpc/setloggernotes'
                        diary={reproduction['diary']}
                    />
                }
            </Cards>
        </>
    )
}

export default Reproduction
